import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from '../reduxModules';
const isDev = process.env.NODE_ENV !== 'production';
const logger = createLogger({
    level: 'info',
    collapsed: true,
});
export function createStore(preloadedState) {
    const store = configureStore({
        reducer: rootReducer,
        preloadedState: preloadedState,
        middleware: (getDefaultMiddleware) => {
            const middleware = getDefaultMiddleware({
                serializableCheck: {
                    // Ignore non-serializable values in certain paths if needed
                    ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
                    ignoredPaths: ['items.dates'],
                },
            });
            return isDev ? middleware.concat(logger) : middleware;
        },
        devTools: isDev,
    });
    // Hot module replacement support
    if (isDev && module.hot) {
        module.hot.accept('../reduxModules', () => {
            // eslint-disable-next-line global-require
            const newRootReducer = require('../reduxModules').default;
            store.replaceReducer(newRootReducer);
        });
    }
    return store;
}
// Default export for backward compatibility
export default createStore;
